import { render, staticRenderFns } from "./Konami.vue?vue&type=template&id=3cbca755"
import script from "./Konami.vue?vue&type=script&lang=js"
export * from "./Konami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports